import { render, staticRenderFns } from "./ReservaFormulario.vue?vue&type=template&id=08e8a9eb&scoped=true"
import script from "./ReservaFormulario.vue?vue&type=script&lang=js"
export * from "./ReservaFormulario.vue?vue&type=script&lang=js"
import style0 from "./ReservaFormulario.vue?vue&type=style&index=0&id=08e8a9eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e8a9eb",
  null
  
)

export default component.exports